import { CircularProgress } from "@material-ui/core";
import React from "react";
import { PrimaryBackgroundColor } from "../../styles/colors";
import "./style.css";

export const Loader = () => {
  return (
    <div className="loader-container">
      <CircularProgress
        style={{ color: PrimaryBackgroundColor, height: 20, width: 20 }}
      />
    </div>
  );
};
